
import { mapGetters } from "vuex";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";
import { SistemaMixin } from "@/modules/Application";
import Link from "vue-material-design-icons/LinkPlus.vue";

export default {
  name: "app-links",
  mixins: [SistemaMixin],
  components: {
    TrashCanIcon,
    TableApp,
    Link,
  },
  data() {
    return {
      fields: [
        {
          label: "Código",
          field: "id_link",
          type: "text",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar link",
          },
        },
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
          width: "25%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar descrição",
          },
        },
        {
          label: "Destinatário",
          field: "nome_destinatario",
          type: "text",
          slot: true,
          sortable: false,
          width: "10%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar pelo destinatário",
          },
        },
        {
          label: "Preço",
          field: "valor",
          sortable: false,
          slot: true,
        },
        {
          label: "Data Expiração",
          field: "data_expiracao",
          sortable: false,
          slot: true,
          width: "5%",
        },
        {
          label: "Data Pagamento",
          field: "data_pagamento",
          sortable: false,
          slot: true,
          width: "5%",
        },
        {
          label: "Parcelas(x)",
          field: "vezes",
          sortable: false,
          slot: true,
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    doCopy(data) {
      this.$copyText(data.link_pagamento);
      this.$toast.success("Link copiado com sucesso!");
    },
    excluir(data) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o Link " + data.id_link + "?",
            showCancelButton: true,
            confirmButtonText: `Sim`,
            cancelButtonText: `Não`,
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/link/delete", {
                id_link: data.id_link,
              });
              this.$refs.links.refresh();
              this.$toast.success("Link excluído!");
            }
          });
      })
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
